import React from 'react'
import { useAuth } from '@/features/auth'
import DashboardLayout from '@/features/dashboard/pages/DashboardLayout'
import { useSubscription } from '@/features/subscription/hooks/useSubscription'
import { AccountHeader } from '../components/AccountHeader'
import { ProfileSection } from '../components/ProfileSection'
import { SubscriptionSection } from '../components/SubscriptionSection'

const AccountPage = () => {
    const { user } = useAuth()
    const { subscription, creditBalance, isActive, isPending, loading } = useSubscription()

    const maxCredits = subscription?.maxCredits || 100

    return (
        <DashboardLayout>
            <div className="p-8 max-w-5xl mx-auto space-y-8 animate-in fade-in duration-500">
                <AccountHeader 
                    title="Account Settings" 
                    description="Manage your profile information and your creative workspace."
                />

                <div className="grid gap-8 md:grid-cols-3">
                    <div className="md:col-span-2">
                        <ProfileSection user={user} />
                    </div>

                    <div>
                        <SubscriptionSection 
                            planName={subscription?.planName || subscription?.plan || ''}
                            creditBalance={creditBalance}
                            maxCredits={maxCredits}
                            isActive={isActive}
                            isPending={isPending}
                            loading={loading}
                        />
                    </div>
                </div>
            </div>
        </DashboardLayout>
    )
}

export default AccountPage
